<template>
  <div class="”picker“">
    <a-select v-model="form.year" style="width:200px;margin-right: 20px;" @change="change">
      <a-select-option v-for="(val, key) in options.year" :key="key" :value="val">{{ val }}年</a-select-option>
    </a-select>
    <a-select v-model="form.month" style="width: 150px;margin-right: 20px;" @change="change">
      <a-select-option v-for="(val, key) in options.month" :key="key" :value="val">{{ val }}月</a-select-option>
    </a-select>
    <a-button @click="reset">重置</a-button>
  </div>
</template>

<script>
import { getDate } from '@/utils';
export default {
  data() {
    return {
      form: {
        year: '',
        month: '',
      },
      options: {
        year: [2017, 2018, 2019, 2020],
        month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    };
  },
  created() {
    var today = getDate('yyyy/M').split('/');
    this.options.year.push(parseInt(today[0]));
    this.form.year = parseInt(today[0]);
    this.form.month = parseInt(today[1]);
    this.$emit('change', this.form);
  },
  methods: {
    change() {
      this.$emit('change', this.form);
    },
    reset() {
      var today = getDate('yyyy/M').split('/');
      this.form.year = parseInt(today[0]);
      this.form.month = parseInt(today[1]);
      this.change();
    },
  },
};
</script>

<style lang="less" scoped>
.picker {
  display: flex;
}
</style>
